/* Reviews band, read more (item 161, 9 Sept).

   Bianca, on a product page with one very long review beside two short ones:
   "this review is just taking up so much space, and when you're scrolling
   there's a lot of dead space next to it. Maybe it's a load more, so you only
   get short paragraphs and then you can load more if you want."

   The CSS clamps every card in the band to seven lines. This adds the button,
   and ONLY on the cards that are actually cut off: a five-line review with a
   Read more under it would be worse than the problem. scrollHeight against
   clientHeight is the test, and it is re-run after the webfonts land and on
   resize, because both change where the seventh line falls. */
(function () {
  var cards = [].slice.call(document.querySelectorAll('.wn-rev--compact'));
  if (!cards.length) return;

  var pairs = [];
  cards.forEach(function (card) {
    var text = card.querySelector('[data-wn-clamp]');
    var more = card.querySelector('[data-wn-clamp-more]');
    if (!text || !more) return;
    pairs.push({ text: text, more: more });

    more.addEventListener('click', function () {
      var open = text.classList.toggle('is-open');
      more.textContent = open ? 'Show less' : 'Read more';
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  function measure() {
    pairs.forEach(function (p) {
      // An open card is taller than its clamp by definition; leave it alone.
      if (p.text.classList.contains('is-open')) return;
      p.more.hidden = p.text.scrollHeight <= p.text.clientHeight + 2;
    });
  }

  measure();
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(measure).catch(function () {});
  }
  window.addEventListener('load', measure);

  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(measure, 150);
  }, { passive: true });
})();
